import { useEffect } from 'react'

import { useCreation, useMemoizedFn, useSetState } from 'ahooks'

import { useMatchedResources } from '../../../hooks/useMatchedResources'

import { SiderMenuStore } from './interface'
import { useVisibleMenus } from './useVisibleMenus'

export const useSiderMenuStore = () => {
  const visibleMenus = useVisibleMenus()
  const paths = useMatchedResources(visibleMenus)
  const selectedKeys = useCreation(() => paths.map(item => item.key), [paths])

  const [state, setState] = useSetState({
    openKeys: selectedKeys,
    selectedKeys
  })

  useEffect(() => {
    setState({
      selectedKeys
    })
  }, [selectedKeys, setState])

  const store: SiderMenuStore = {
    ...state,
    menus: visibleMenus,
    setOpenKeys: useMemoizedFn((openKeys: string[]) => {
      setState({
        openKeys
      })
    }),
    setSelectedKeys: useMemoizedFn(({ selectedKeys }) => {
      setState({
        selectedKeys
      })
    })
  }

  return store
}
